export const toRem = (size: string | number = 0) => {
  return typeof size === 'number' ? `${size / 10}rem` : size;
};

export const pt = (size: string | number = 0): string => {
  const s = typeof size === 'string' ? Number(size.replaceAll('pt', '')) : size;
  return `${s * 0.75}pt`;
};

export const ptToPx = (size: string | number = 0): number => {
  return typeof size === 'number' ? Math.round(size * 1.3333) : Number(size);
};

export const hasFocusedInput = () => document.activeElement?.tagName === 'INPUT';

export const hasOpenedPopover = () => (document.getElementById('popovers')?.children || []).length > 0;
